export const SSHelper = {
  getPrimitive<T extends string = string>(key: string) {
    return sessionStorage.getItem(key) as T | null;
  },
  getObject<T extends object>(key: string): T | null {
    try {
      return JSON.parse(sessionStorage.getItem(key) || '');
    } catch (e) {
      console.warn(`Could not get ${key} from LS: ${e}`);
    }

    return null;
  },
  setItem<T = any>(key: string, data: T) {
    sessionStorage.setItem(key, JSON.stringify(data));
  },
  removeItem(key: string) {
    sessionStorage.removeItem(key);
  },

  clear() {
    sessionStorage.clear();
  },
};
